import CompanyEquipmentsTable from "./CompanyEquipmentsTable";
import React, { useRef, useState } from "react";
import EquipmentFilters from "./Filters";
import { debounce } from "lodash/fp";
import { isEqual } from "lodash";
import { Grid } from "@mui/material";
import { useQuery } from "@apollo/client/react";
import { GetCompanyResourcesDocument, CompanyResourceResourceTypeEnum, CompanyResource } from "@/graphql/generated/graphql";

const DEFAULT_FILTERS = {
  resourceCategoryId: ""
};
const normalDebounce = debounce(500);

export type EquipmentsFiltersType = typeof DEFAULT_FILTERS;

const EquipmentManagement: React.FC = () => {
  const debounceFunc = useRef(normalDebounce(fn => fn())).current;
  const [filters, setFilters] = useState<EquipmentsFiltersType>(DEFAULT_FILTERS);

  const { data, refetch, loading } = useQuery(GetCompanyResourcesDocument, {
    fetchPolicy: "network-only",
    variables: {
      resourceType: CompanyResourceResourceTypeEnum.Equipment,
      ...filters
    }
  });

  const handleOnChange = <K extends keyof EquipmentsFiltersType>(key: K, value: EquipmentsFiltersType[K]) => {
    setFilters((prev) => {
      const newState = { ...prev, [key]: value };

      debounceFunc.cancel();
      debounceFunc(() => refetch(newState))

      return newState;
    })
  };
  const handleOnReset = () => {
    setFilters(DEFAULT_FILTERS);
    refetch(DEFAULT_FILTERS);
  }

  return (
    <Grid container>
      <EquipmentFilters
        filters={filters}
        onChange={handleOnChange}
        onReset={handleOnReset}
        disableReset={isEqual(filters, DEFAULT_FILTERS)}
      />

      <CompanyEquipmentsTable
        loading={loading}
        data={data?.getCompanyResources as CompanyResource[] || []}
      />
    </Grid>
  );
};

export default EquipmentManagement;
